export default __webpack_public_path__ + "static/media/Kaml Kant Gouri.07d8e17b.png";